import { TaggedError } from "@for-it/domain-lib";
export class TenantBootstrapFailedError extends TaggedError {
    step;
    reason;
    constructor(step, reason) {
        super("TenantBootstrapFailedError");
        this.step = step;
        this.reason = reason;
    }
}
